import PropTypes from 'prop-types';
import { Expander } from 'cat-ecommerce-alloy';
import cx from 'classnames';
import { getSpecifications } from './utils';
import styles from './ProductComparisonCard.module.scss';
import { useBreakpoint } from '../../../../../hooks';
import { PAGE_BREAKPOINTS } from '../../../../../constants/commonConstants';
import { useTranslation } from 'react-i18next';

export const ProductComparisonCardSpecifications = ({
  manufacturer,
  shortDescription,
  attributes,
  expanded,
  setExpanded
}) => {
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.LG);
  const { t } = useTranslation();
  const specifications = insideExpander => (
    <div className={cx({ 'position-relative': isLG })}>
      <div
        className={cx(
          {
            'position-absolute': isLG,
            [`${styles['product-item--hidden']}`]: !insideExpander,
            [`${styles['product-item--expander-content']}`]:
              insideExpander && isMD,
            'rounded-bottom border-bottom border-end border-start': isMD
          },
          'px-3 py-2'
        )}
      >
        {manufacturer ? (
          <p className="text-sans-serif color-dark-gray text-sm fw-bold mb-0">
            {manufacturer}
          </p>
        ) : null}
        {getSpecifications(shortDescription, attributes)}
      </div>
    </div>
  );

  return !isLG ? (
    <div
      className={cx({
        'position-relative': isMD,
        [`${styles['product-item--expander-wrapper']}`]: isMD
      })}
    >
      <Expander
        id="specsExpander"
        className={cx({
          'position-absolute': isMD,
          [`${styles['product-item--expander']}`]: isMD
        })}
        buttonLabel={t('VIEW_SPECIFICATIONS')}
        buttonClassName={cx(
          styles['product-item--expander-button'],
          { [`${styles['product-item--expander-button-mobile']}`]: !isMD },
          'px-3 py-3 btn-lg justify-content-between align-self-stretch text-md text-univers--bold'
        )}
        buttonWrapperClassName="w-100"
        expanded={expanded}
        setExpanded={setExpanded}
      >
        {specifications(true)}
      </Expander>
    </div>
  ) : (
    specifications(false)
  );
};
export default ProductComparisonCardSpecifications;

ProductComparisonCardSpecifications.propTypes = {
  manufacturer: PropTypes.string,
  shortDescription: PropTypes.string,
  attributes: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)),
  expanded: PropTypes.bool,
  setExpanded: PropTypes.func
};
